/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_No_Errors_FoundInputs */



/**
* | output |
* | --- |
* | "No errors found. All events passed the review." |
*
* @param {Qc_No_Errors_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_no_errors_found = /** @type {((inputs?: Qc_No_Errors_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_No_Errors_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune erreur trouvée. Tous les événements ont réussi la révision.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Fehler gefunden. Alle Events haben die Prüfung bestanden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun errore trovato. Tutti gli eventi hanno superato la revisione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибок не найдено. Все события прошли проверку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron errores. Todos los eventos pasaron la revisión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未发现错误。所有事件均通过审阅。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーは見つかりませんでした。すべてのイベントがレビューに合格しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई त्रुटि नहीं मिली। सभी इवेंट समीक्षा में पास हुए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontrados erros. Todos os eventos passaram a revisão.")
	return /** @type {LocalizedString} */ ("No errors found. All events passed the review.")
});